import { SvgIcon, type SvgIconProps } from "@material-ui/core";

export default function (props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <circle opacity="0.2" cx="16" cy="16" r="16" />
      <path d="M16 6C10.48 6 6 10.48 6 16C6 21.52 10.48 26 16 26C21.52 26 26 21.52 26 16C26 10.48 21.52 6 16 6Z" />
      <path
        d="M16 17C15.45 17 15 16.55 15 16V12C15 11.45 15.45 11 16 11C16.55 11 17 11.45 17 12V16C17 16.55 16.55 17 16 17Z"
        fill={props.htmlColor ?? "white"}
      />
      <path
        d="M17 20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19C16.5523 19 17 19.4477 17 20Z"
        fill={props.htmlColor ?? "white"}
      />
    </SvgIcon>
  );
}
